import type { ProductDayTripPlanI18nFormModel } from "../../../../../type";
import type { ServerModel } from "../../type";

export const serverModelToInputModelConverter = (
	serverModel: ServerModel,
): ProductDayTripPlanI18nFormModel["InputModel"] => {
	const { planI18n, planCustomMailSettingI18n, basicCustomMailSettingI18n } = serverModel;

	const inputModel: ProductDayTripPlanI18nFormModel["InputModel"] = {
		hotelID: planI18n.hotelID,
		planID: planI18n.planID,
		lang: planI18n.lang,

		name: planI18n.name,
		mainTarget: planI18n.mainTarget,

		emailTemplateReservation: planI18n.emailTemplateReservation,

		questions: planI18n.questions,

		atCreated: {
			text:
				planCustomMailSettingI18n?.forReservation?.atCreated?.text ??
				basicCustomMailSettingI18n?.forReservation?.atCreated?.text ??
				"",
			override: planCustomMailSettingI18n?.forReservation?.atCreated?.override ?? false,
		},
		atUpdated: {
			text:
				planCustomMailSettingI18n?.forReservation?.atUpdated?.text ??
				basicCustomMailSettingI18n?.forReservation?.atUpdated?.text ??
				"",
			override: planCustomMailSettingI18n?.forReservation?.atUpdated?.override ?? false,
		},
		atCanceled: {
			text:
				planCustomMailSettingI18n?.forReservation?.atCanceled?.text ??
				basicCustomMailSettingI18n?.forReservation?.atCanceled?.text ??
				"",
			override: planCustomMailSettingI18n?.forReservation?.atCanceled?.override ?? false,
		},
		atCheckInBefore_00days: {
			text:
				planCustomMailSettingI18n?.forReservation?.atCheckInBefore_00days?.text ??
				basicCustomMailSettingI18n?.forReservation?.atCheckInBefore_00days?.text ??
				"",
			shouldSendEmail:
				planCustomMailSettingI18n?.forReservation?.atCheckInBefore_00days?.shouldSendEmail ??
				basicCustomMailSettingI18n?.forReservation?.atCheckInBefore_00days?.shouldSendEmail ??
				false,
			override: planCustomMailSettingI18n?.forReservation?.atCheckInBefore_00days?.override ?? false,
		},
		atCheckInBefore_01days: {
			text:
				planCustomMailSettingI18n?.forReservation?.atCheckInBefore_01days?.text ??
				basicCustomMailSettingI18n?.forReservation?.atCheckInBefore_01days?.text ??
				"",
			shouldSendEmail:
				planCustomMailSettingI18n?.forReservation?.atCheckInBefore_01days?.shouldSendEmail ??
				basicCustomMailSettingI18n?.forReservation?.atCheckInBefore_01days?.shouldSendEmail ??
				false,
			override: planCustomMailSettingI18n?.forReservation?.atCheckInBefore_01days?.override ?? false,
		},
		atCheckInBefore_07days: {
			text:
				planCustomMailSettingI18n?.forReservation?.atCheckInBefore_07days?.text ??
				basicCustomMailSettingI18n?.forReservation?.atCheckInBefore_07days?.text ??
				"",
			shouldSendEmail:
				planCustomMailSettingI18n?.forReservation?.atCheckInBefore_07days?.shouldSendEmail ??
				basicCustomMailSettingI18n?.forReservation?.atCheckInBefore_07days?.shouldSendEmail ??
				false,
			override: planCustomMailSettingI18n?.forReservation?.atCheckInBefore_07days?.override ?? false,
		},
		atCheckOutAfter_01days: {
			text:
				planCustomMailSettingI18n?.forReservation?.atCheckOutAfter_01days?.text ??
				basicCustomMailSettingI18n?.forReservation?.atCheckOutAfter_01days?.text ??
				"",
			shouldSendEmail:
				planCustomMailSettingI18n?.forReservation?.atCheckOutAfter_01days?.shouldSendEmail ??
				basicCustomMailSettingI18n?.forReservation?.atCheckOutAfter_01days?.shouldSendEmail ??
				false,
			override: planCustomMailSettingI18n?.forReservation?.atCheckOutAfter_01days?.override ?? false,
		},
	} satisfies ProductDayTripPlanI18nFormModel["InputModel"];

	return inputModel;
};
